import * as ng from 'angular';

export const BarChart = () => (<angular.IDirective>{

    restrict: 'AE',

    link: (scope: ng.IScope, element: JQuery, attrs: JQLite) => {
        // ??
    },
    controller: ($scope) => {
        // ??
    }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/bar-chart/bar-chart.directive.ts